import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import '../../LinkModal.css';
import './Paywall.css';

import IconClose from '../../../svg/IconClose';
import LogoLink from '../../beatport/svg/LogoLink';
const LMC1 = require(`../media/LMC1.png`);
const LMC2 = require(`../media/LMC2.png`);
const LMC3 = require(`../media/LMC3.png`);

function LinkModal({ cancelClick, modalHasEntered }) {
  const storeAuth = useSelector(state => state.storeAuth);
  const redirect = () => { window.open(`https://www.beatport.com/subscriptions?utm_medium=referral&utm_source=nextbeat.you.dj&utm_campaign=link_nextbeat`, `_blank`) }

  const session = parseInt(localStorage.getItem('AvCCg6ct4RfyS'));
  const version = (session <= 3) ? 1 : ((session <= 5) ? 2 : 3);

  const cover = (version === 1) ? LMC1 : ((version === 2) ? LMC2 : LMC3 );
  const cta = (version === 1) ? `Start your free trial` : ((version === 2) ? `Start your trial` : `Plans start at $9.99` );
  const connect = () => { storeAuth.welcome(false); }

  return (
    <div className={`flexColumn linkModal paywall`}>
      <div className={`flexRow`}>
        <div className={`p-cover`}>
          <img src={cover} alt={`Beatport LINK`} />
        </div>
        <div className={`flexColumn p-container`}>
          {(version === 1 || version === 2) && <IconClose size={16} color={`#FAFAFA`} onClick={cancelClick} className={`icon-close`} />}
          <div className={`logo`}>
            <LogoLink className={`logo-link`} />
          </div>

          { (version === 1) && (
            <>
              {/* <div className={`title type-title p-title p0-0`}>Try LINK,</div> */}
              <div className={`title type-title p-title p0-1`}>Unlock Full</div>
              <div className={`title type-title p-title p0-2`}>Track Playback</div>
              <div className={`type-regular p-caption-0`}>Beatport DJ is your one-stop web browser solution for digging, discovery and playlist creation. Immerse yourself in the curated selections from our team of genre experts with your Next Beat Controller</div>
            </>
          )}
          { (version === 2) && (
            <>
              {/* <div className={`title type-title p-title p1-0`}>Try LINK,</div> */}
              <div className={`title type-title p-title p1-1`}>Unlock your</div>
              <div className={`title type-title p-title p1-2`}>DJ potential</div>
              <div className={`type-regular p-caption-1`}>
                * Mobile App <br />
                * DJ Web App <br />
                * Full Track Playback <br />
                * Personalised Library <br />
                * Professionally Curated Playlists <br />
                * DJ Software and Hardware integarations <br />
                * Play Offline (Pro Only)
              </div>
            </>
          )}
          { (version === 3) && (
            <>
              <div className={`title type-title p-title p2-0`}>Start your</div>
              <div className={`title type-title p-title p2-1`}>free trial</div>
              <div className={`type-regular p-caption-2`}>Subscribe to one of Beatport’s plans free for  30-days to access a world of music discovery and suite of DJ performance tools.</div>
              <div className={`p-cta-connect`} onClick={connect}>Connect</div>
            </>
          )}

          <div className={`p-cta`} onClick={redirect}>{cta}</div>
        </div>
      </div>
    </div>
  )
}

LinkModal.propTypes = {
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool
}

export default LinkModal;
